import { replaceWhiteLabelTitle } from 'library-@/utils/replaceWhiteLabelTitle';

export default function setTitle({ locale = 'en', isWhiteLabel = false }) {
    const title = {
        cn: 'Homepage - 智慧芽',
        en: 'Homepage - Patsnap',
        jp: 'Homepage - Patsnap',
        de: 'Homepage - Patsnap',
        tw: 'Homepage - 智慧芽'
    };
    document.title = replaceWhiteLabelTitle({ title: title[locale] || title['en'], isWhiteLabel });
}
